import React, { useEffect } from "react";
import AssignAssessorComponent from "../../components/applicationComponents/assignAssessor/AssignAssessorComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function AssignAssessorPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Assign Assessor",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <AssignAssessorComponent disabled={false} />
    </>
  );
}
